import type { CellRendererProps } from './index';

export function TextCell({ value, config }: CellRendererProps) {
  const muted = (config?.muted as boolean) ?? false;
  const fallback = (config?.fallback as string) ?? '-';

  const display = value != null && value !== '' ? String(value) : fallback;

  return (
    <span className={muted ? 'text-sm text-muted-foreground' : 'text-sm'}>
      {display}
    </span>
  );
}
